import request from '@/utils/request2'

// 列表(主数据列表)
export function loadStoreVisitCheckInfoListDataApi(data) {
  return request({
    url: 'tms-web/storeVisitCheckInfo/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportStoreVisitCheckInfoListDataApi(data) {
  return request({
    url: 'tms-web/storeVisitCheckInfo/exportByPage',
    method: 'post',
    data
  })
}

// 查看
export function viewStoreVisitCheckInfoApi(data) {
  return request({
    url: 'tms-web/storeVisitCheckInfo/view',
    method: 'post',
    data
  })
}
